/** A piece of `Markup` text: a paragraph of inline markup, or a fenced code example. */
export type MarkupBlock = { kind: 'para'; text: string } | { kind: 'code'; code: string };

const FENCE = /^\s*```/;

/**
 * Splits text into paragraphs (at blank lines) and ```fenced``` code blocks. Code keeps its line
 * breaks and indentation; a fence the text never closes runs to the end.
 */
export function markupBlocks(text: string): MarkupBlock[] {
  const blocks: MarkupBlock[] = [];
  const prose: string[] = [];
  const flush = () => {
    for (const para of prose.join('\n').split(/\n\s*\n/)) {
      if (para.trim() !== '') blocks.push({ kind: 'para', text: para.trim() });
    }
    prose.length = 0;
  };
  let code: string[] | null = null;
  for (const line of text.split('\n')) {
    if (FENCE.test(line)) {
      if (code === null) {
        flush();
        code = [];
      } else {
        blocks.push({ kind: 'code', code: code.join('\n') });
        code = null;
      }
    } else if (code !== null) {
      code.push(line);
    } else {
      prose.push(line);
    }
  }
  if (code !== null) blocks.push({ kind: 'code', code: code.join('\n') });
  flush();
  return blocks;
}
